<div class="order-details"
     [mmTestId]="'ORDER.PAYMENT_SHIPPING_INFO'">
    <mm-accordion>
        <mm-accordion-item [title]="'PAGES.ACCOUNT.ORDERS_HISTORY.PAYMENT_AND_SHIPMENT.TITLE' | translate"
                           [expanded]="isFirstOrder" (selected)="isExpanded($event)">
            <div class="order-details-content">
                <div class="order-details-content__info-block">
                    <div class="order-details-delivery-line">
                        <div class="order-details-delivery-line__title"
                             [mmTestTarget]="'ordering-date-label'">
                            {{ 'PAGES.ACCOUNT.ORDERS_HISTORY.ORDERING_DATE' | translate }}:
                        </div>
                        <div class="order-details-delivery-line__value"
                             [mmTestTarget]="'ordering-date-value'">
                            {{order?.createdAt | date: dateFormat}}
                        </div>
                    </div>
                    <div class="order-details-delivery-line">
                        <div class="order-details-delivery-line__title"
                             [mmTestTarget]="'ordering-paidBy-label'">
                            {{ 'PAGES.ACCOUNT.ORDERS_HISTORY.PAYED_BY' | translate }}:
                        </div>
                        <div class="order-details-delivery-line__value"
                             [mmTestTarget]="'ordering-paidBy-value'">
                          <div class="order-details-delivery-line__value__4x-label"
                               *ngIf="order?.payment?.methodCode === paymentMethodCode.paypalInsFr">
                            {{ 'PAGES.ACCOUNT.ORDERS_HISTORY.PAYMENT.PAYPAL_INS_FRANCE' | translate }}
                          </div>
                          <div [ngClass]="order?.payment?.methodCode === paymentMethodCode.paypalInsFr ? 'order-details-delivery-line__value__4x-logo' : ''"
                               *ngIf="isEnabledPaymentMethodCode? (order?.payment?.methodCode === paymentMethodCode.paypal || order?.payment?.methodCode === paymentMethodCode.paypalInsFr) : (order?.payment?.method === paymentMethod.paypal || order?.payment?.method === paymentMethod.paypalInsFr); else paymentMethodName">
                            <mm-icon class="order-details-delivery-line__value-icon"
                                     [isCurrentColor]="false"
                                     name="paypal-logo">
                            </mm-icon>
                          </div>
                        </div>
                        <ng-template #paymentMethodName>{{ order?.payment?.name }}</ng-template>
                    </div>
                    <div class="order-details-delivery-line">
                        <div class="order-details-delivery-line__title"
                             [mmTestTarget]="'billing-address-label'">
                            {{ 'PAGES.ACCOUNT.ORDERS_HISTORY.BILLING_ADDRESS' | translate }}:
                        </div>
                        <div class="order-details-delivery-line__value"
                             [mmTestTarget]="'billing-address-value'"
                             data-hj-suppress>
                            <app-order-history-details-address [address]="order?.address?.billing">
                            </app-order-history-details-address>
                        </div>
                    </div>
                    <div class="order-details-delivery-line">
                        <div class="order-details-delivery-line__title"
                             [mmTestTarget]="'shipping-address-label'">
                            {{ 'PAGES.ACCOUNT.ORDERS_HISTORY.SHIPPING_ADDRESS' | translate }}:
                        </div>
                        <div class="order-details-delivery-line__value"
                             [mmTestTarget]="'shipping-address-value'"
                             data-hj-suppress>
                            <app-order-history-details-address [address]="order?.address?.shipping">
                            </app-order-history-details-address>
                        </div>
                    </div>
                </div>
                <div class="order-details-content__info-block order-details-content__info-block--payment-section">
                    <app-order-history-details-payment [order]="order" [isEntrepreneur]="order?.buyer?.type?.value === buyerType.entrepreneur">
                    </app-order-history-details-payment>
                </div>
            </div>

            <div *ngIf="(isEnabledPaymentMethodCode)? (order?.payment?.methodCode === paymentMethodCode.openInvoice) : (order?.payment?.method === paymentMethod.openInvoice)"
                 class="mt-gutter">
                <mm-alert [alertConfig]="openInvoiceAlertConfig"></mm-alert>
            </div>
            <ng-template #openInvoiceAlertTemplate>
                <div class="order-details__open-invoice-info"
                     [mmTestTarget]="'rate-pay-invoice-info'">
                    <p class="mb-gutter-xs">{{ 'PAGES.ACCOUNT.ORDERS_HISTORY.RATEPAY_NOTICE.TEXT' | translate }}</p>
                    <p><b>{{ 'PAGES.ACCOUNT.ORDERS_HISTORY.RATEPAY_NOTICE.EXTRA' | translate }}</b></p>
                </div>
            </ng-template>

        </mm-accordion-item>
    </mm-accordion>
</div>
